import i18next from "i18next";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import { initReactI18next } from "react-i18next";

export default function init(lang: string, appVersion: string) {
    return i18next
        .use(ChainedBackend)
        .use(initReactI18next)
        .init({
            lng: lang,
            fallbackLng: lang,
            load: "currentOnly",
            backend: {
                backends: [LocalStorageBackend, HttpBackend],
                backendOptions: [
                    {
                        loadPath: "/locales/{{lng}}.json",
                        defaultVersion: appVersion,
                    },
                    {
                        loadPath: "/locales/{{lng}}.json",
                        defaultVersion: appVersion,
                    },
                ],
            },
        });
}
